var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPlayerStop = function SvgPlayerStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Player_stop_svg__Player_stop_svg__clip0_7166_718)",
    stroke: "#48525C",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 100-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.571A.571.571 0 018.571 8h2.858a.571.571 0 01.571.571v2.858a.571.571 0 01-.571.571H8.57a.571.571 0 01-.57-.571V8.57z",
    fill: "#48525C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Player_stop_svg__Player_stop_svg__clip0_7166_718"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPlayerStop;